import { defineStore } from 'pinia'
import { api } from '~/api/apis'
import type { ParameterdListData } from '~/api/schemas/parameterd-list-data'

/** 參數 */
export const useAdminParameterdStore = defineStore('adminParameterd', () => {
  /** 列表 */
  const list = ref<ParameterdListData[]>([])
  /** 服務項目列表 */
  const serviceClassList = ref<ParameterdListData[]>([])
  /** 問題層級列表 */
  const serviceUrgentList = ref<ParameterdListData[]>([])
  /** 問題項目列表 */
  const serviceStatusList = ref<ParameterdListData[]>([])
  /** 角色類型列表 */
  const roleClassList = ref<ParameterdListData[]>([])
  /** 帳號狀態列表 */
  const accountStatusList = ref<ParameterdListData[]>([])
  /** TPI Email 帳號尾碼 */
  const tpEmailList = ref<ParameterdListData[]>([])

  /** 設定列表 */
  function setList(value: ParameterdListData[]) {
    list.value = value
  }

  /** 設定服務項目列表 */
  function setServiceClassList(value: ParameterdListData[]) {
    serviceClassList.value = value
  }

  /** 設定問題層級列表 */
  function setServiceUrgentList(value: ParameterdListData[]) {
    serviceUrgentList.value = value
  }

  /** 設定問題項目列表 */
  function setServiceStatusList(value: ParameterdListData[]) {
    serviceStatusList.value = value
  }

  /** 設定角色類型列表 */
  function setRoleClassList(value: ParameterdListData[]) {
    roleClassList.value = value
  }

  /** 設定帳號狀態列表 */
  function setAccountStatusList(value: ParameterdListData[]) {
    accountStatusList.value = value
  }

  /** 設定 TPI Email 帳號尾碼列表 */
  function setTpEmailList(value: ParameterdListData[]) {
    tpEmailList.value = value
  }

  /** 取得列表 */
  async function getList() {
    const getParameterdListResult = await useAdminApi(
      api.getParameterdList({
        isEnable: [1]
      })
    ).call({
      action: 'read'
    })

    if (getParameterdListResult.success) {
      setList(getParameterdListResult.response.data ?? [])
    }
  }

  /** 取得服務項目列表 */
  async function getServiceClassList() {
    const getParameterdListResult = await useAdminApi(
      api.getParameterdList({
        isEnable: [1],
        pmCode: 'serviceClass'
      })
    ).call({
      action: 'read'
    })

    if (getParameterdListResult.success) {
      setServiceClassList(getParameterdListResult.response.data ?? [])
    }
  }

  /** 取得問題層級列表 */
  async function getServiceUrgentList() {
    const getParameterdListResult = await useAdminApi(
      api.getParameterdList({
        isEnable: [1],
        pmCode: 'serviceUrgent'
      })
    ).call({
      action: 'read'
    })

    if (getParameterdListResult.success) {
      setServiceUrgentList(getParameterdListResult.response.data ?? [])
    }
  }

  /** 取得問題狀態列表 */
  async function getServiceStatusList() {
    const getParameterdListResult = await useAdminApi(
      api.getParameterdList({
        isEnable: [1],
        pmCode: 'serviceStatus'
      })
    ).call({
      action: 'read'
    })

    if (getParameterdListResult.success) {
      setServiceStatusList(getParameterdListResult.response.data ?? [])
    }
  }

  /** 取得角色類型列表 */
  async function getRoleClassList() {
    const getParameterdListResult = await useAdminApi(
      api.getParameterdList({
        isEnable: [1],
        pmCode: 'roleClass'
      })
    ).call({
      action: 'read'
    })

    if (getParameterdListResult.success) {
      setRoleClassList(getParameterdListResult.response.data ?? [])
    }
  }

  /** 取得帳號狀態列表 */
  async function getAccountStatusList() {
    const getParameterdListResult = await useAdminApi(
      api.getParameterdList({
        pmCode: 'accountStatus'
      })
    ).call({
      action: 'read'
    })

    if (getParameterdListResult.success) {
      setAccountStatusList(getParameterdListResult.response.data ?? [])
    }
  }

  /** 取得 TPI Email 帳號尾碼列表 */
  async function getTpEmailList() {
    const getParameterdListResult = await useAppApi(
      api.getParameterdList({
        isEnable: [1],
        pmCode: 'tpEmail'
      })
    ).call()

    if (getParameterdListResult.success) {
      setTpEmailList(getParameterdListResult.response.data ?? [])
    }
  }

  return {
    list,
    serviceClassList,
    serviceUrgentList,
    serviceStatusList,
    roleClassList,
    accountStatusList,
    tpEmailList,
    setList,
    setServiceClassList,
    setServiceUrgentList,
    setServiceStatusList,
    setRoleClassList,
    getList,
    getServiceClassList,
    getServiceUrgentList,
    getServiceStatusList,
    getRoleClassList,
    getAccountStatusList,
    getTpEmailList
  }
})
